import { BASE_URL } from 'config/urls';

import { post, requestSdk } from 'utils/sdk';

export const trackerUpdate = async (trackerId, data) =>
  await requestSdk(() =>
    post(`${BASE_URL}/v1/trackers/${trackerId}/update/`, data)
  );
